import {Link as RouterLink} from 'react-router-dom';
import { ListItem, ListItemButton, ListItemText, ListItemIcon, Typography, Link as MuiLink } from '@mui/material';

export default function MyListItem({href, text, isSelected, disable, source, alt, onClick}) {
    return(
    <ListItem disablePadding 
              selected={isSelected}
              sx={{
                pointerEvents: disable ? 'none' : 'auto',
                opacity: disable ? 0.5 : 1,
                minWidth: 0
              }}>
        <MuiLink
            component={RouterLink}
            onClick={onClick} 
            to={href} 
            sx={{width: '100%', backgroundColor:isSelected ? 'grey.300' : 'white'}} underline="none" color="fontTheme">
            <ListItemButton sx={{paddingLeft: '10px'}}>
                <ListItemIcon className='list-item-icon'>
                    <img src={source} alt={alt} className='item-icon'/>
                </ListItemIcon>
                <ListItemText primary={<Typography className='link-item-text'>{text}</Typography>} />
            </ListItemButton>
        </MuiLink>
    </ListItem>
    )
}